import dayjs from "dayjs";

export const OFFER_SEARCH_ADULTS = 2;
export const OFFER_SEARCH_ROOMS = 1;

const DAYS_UNTIL_CHECK_IN = 30; // 4 weeks from now
const STAY_DURATION_DAYS = 2;

export interface OfferStayDates {
  fromDate: string;
  untilDate: string;
}

/** Check-in 4 weeks from today, checkout 2 days later, as `YYYY-MM-DD` strings. */
export const getDefaultOfferStayDates = (): OfferStayDates => {
  const from = dayjs().add(DAYS_UNTIL_CHECK_IN, "day");
  const until = from.add(STAY_DURATION_DAYS, "day");
  return {
    fromDate: from.format("YYYY-MM-DD"),
    untilDate: until.format("YYYY-MM-DD"),
  };
};
